import { MapPin, CalendarDays, Briefcase } from "lucide-react";
import { COMPANY } from "@/lib/site";

export const CompanyProfile = () => {
  return (
    <section id="profil" data-testid="company-profile-section" className="py-24 lg:py-32 bg-animax-black text-white relative overflow-hidden">
      <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-animax-yellow/10 blur-3xl" />
      <div className="absolute -bottom-10 -left-10 w-64 h-64 rounded-full bg-animax-orange/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="max-w-4xl">
          <div className="tag-uppercase text-animax-yellow mb-4">Profil Perusahaan</div>
          <div className="flex items-center gap-5 mb-6">
            <img
              src={COMPANY.logos.aplTransparent}
              alt="PT Animax Putra Lancar"
              className="h-16 w-16 object-contain bg-white rounded-xl p-1.5"
            />
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium leading-tight">
              PT. Animax Putra Lancar
            </h2>
          </div>
          <p className="text-white/70 text-lg leading-relaxed">
            Didirikan sejak tahun 2021, PT. Animax Putra Lancar adalah perusahaan trading material
            untuk kebutuhan proyek, retail, display, interior, dan industri,
            berlokasi di Mojokerto, Jawa Timur. Kami mengembangkan beberapa lini produk secara
            bertahap, termasuk ANIMAX Acrylic sebagai salah satu brand produk yang saat ini sudah
            tersedia untuk pelanggan di seluruh Indonesia.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="p-5 rounded-2xl bg-white/5 border border-white/10" data-testid="profile-fact-0">
            <CalendarDays className="w-5 h-5 text-animax-yellow mb-3" />
            <div className="tag-uppercase text-white/50">Didirikan</div>
            <div className="mt-1 font-medium">Tahun 2021</div>
          </div>
          <div className="p-5 rounded-2xl bg-white/5 border border-white/10" data-testid="profile-fact-1">
            <Briefcase className="w-5 h-5 text-animax-yellow mb-3" />
            <div className="tag-uppercase text-white/50">Bidang Usaha</div>
            <div className="mt-1 font-medium">Trading Company</div>
          </div>
          <div className="p-5 rounded-2xl bg-white/5 border border-white/10" data-testid="profile-fact-2">
            <MapPin className="w-5 h-5 text-animax-yellow mb-3" />
            <div className="tag-uppercase text-white/50">Lokasi</div>
            <div className="mt-1 font-medium">Mojokerto, Jawa Timur</div>
          </div>
        </div>

        <div className="mt-6 flex items-start gap-3 text-sm text-white/60">
          <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-animax-yellow" />
          <span>{COMPANY.address}</span>
        </div>
      </div>
    </section>
  );
};
